import { useRive } from '@rive-app/react-canvas';
import styled from 'styled-components';
import * as rivs from '../../../assets/animations/riv';
import { IconSizeType, RiveFileNameType } from '../../../interfaces/Element.interfaces';
import { getIconWidthHeight } from '../../../utils/getter/getIconWidthHeight';

interface RiveAnimationProps {
  name: RiveFileNameType;
  size: IconSizeType;
}

export const RiveAnimation = ({ name, size }: RiveAnimationProps) => {
  const riveImage = rivs[name];

  const iconWidthHeight = getIconWidthHeight(size);

  const { RiveComponent } = useRive({
    src: riveImage,
    autoplay: true,
  });

  return (
    <SizeDeterminingWrapper width={iconWidthHeight.width} height={iconWidthHeight.height}>
      <RiveComponent />
    </SizeDeterminingWrapper>
  );
};

const SizeDeterminingWrapper = styled.div<{ width: number; height: number }>`
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
`;
